module.exports = __webpack_public_path__ + "img/slide02.ae66bc0a.png";